import React, { useCallback, useEffect, useState } from "react";

import {
	Create,
	DateInput,
	NumberInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,
	TextInput,
	useCreate,
	useGetIdentity,
	useGetOne,
	useRecordContext,
	useRedirect,
} from "react-admin";

const FundraisersCampaignCreateForm = (props) => {
	const [create] = useCreate("fundraisers_campaign");
	const [campaignId, setCampaignId] = useState(undefined);
	const { data: campaignData } = useGetOne("campaign", { id: campaignId }, {});
	const { identity } = useGetIdentity();
	const redirectTo = useRedirect();

	const record = useRecordContext();

	useEffect(() => {
		record["end_date"] = campaignData?.end_date || null;
	}, [campaignData]);

	useEffect(() => {
		record["user_uid"] = identity?.id || null;
	}, [identity]);

	const { basePath } = props;
	const save = useCallback(
		(values, redirect) => {
			create(
				{
					payload: {
						data: {
							...values,
							key: Math.random().toString(36).slice(2).substr(0, 5),
							user_uid: identity?.id || null,
							end_date: campaignData?.end_date,
							title: campaignData?.abstract_title,
						},
					},
				},
				{
					onSuccess: (newRecord) => {
						redirectTo(redirect, basePath, newRecord.id, newRecord);
					},
				}
			);
		},
		[create, campaignData, identity]
	);

	const now = new Date(Date.now()).toISOString();

	return (
		<SimpleForm {...props} onSubmit={save}>
			<ReferenceInput source="campaign_id" reference="campaign">
				<SelectInput
					label="Campagne"
					validate={required()}
					onChange={(id) => {
						setCampaignId(id)
					}}
					filter={{ end_date: { _gt: now }, start_date: { _lt: now } }}
					optionText="abstract_title"
				/>
			</ReferenceInput>
			<TextInput fullWidth multiline source="description" label="Titre" validate={required()} />
			<DateInput disabled source="end_date" label="Date de fin" validate={required()} />
			<NumberInput source="amount" label="Objectif de collecte" validate={required()} />
		</SimpleForm>
	);
};

const FundraisersCampaignCreate = (props) => {
	return (
		<Create {...props}>
			<FundraisersCampaignCreateForm />
		</Create>
	);
};

export default FundraisersCampaignCreate;
